import { fileUrl } from "@/lib/api";

export const waLink = (number, text) =>
  `https://wa.me/${(number || "").replace(/[^0-9]/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

// Prefilled first message a customer sends from an offer's WhatsApp button.
export const offerMessage = (bizName, o, url) =>
  `Hi ${bizName}, I'm interested in "${o.title}"${o.price ? ` (${o.price})` : ""}.${url ? `\n${url}` : ""}`;

export const offerImages = (o) => (o.images?.length ? o.images : o.image_path ? [o.image_path] : []);

export const timeLeft = (expiresAt) => {
  if (!expiresAt) return "";
  const ms = new Date(expiresAt) - new Date();
  if (ms <= 0) return "";
  const d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5);
  if (d > 7) return "";
  return d > 0 ? `${d}d ${h}h left` : `${h}h left`;
};

export const shareLink = async (title, url) => {
  try {
    if (navigator.share) { await navigator.share({ title, url }); return "shared"; }
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch { return "failed"; }
};

export const imgFallback = (e) => { e.currentTarget.style.display = "none"; };
export { fileUrl };
